import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import LoadingScreen from './pages/LoadingScreen';
import Login from './pages/Login';
import AppLayout from './layouts/AppLayout';

class App extends Component {
  state = {
    appLoaded: false,
  };

  componentDidMount() {
    const { history } = this.props;
    const user = localStorage.getItem('user');
    const userApiToken = localStorage.getItem('userApiToken');
    if (user && userApiToken) {
      // history.push('/app');
      this.appLoaded();
    } else {
      history.push('/login');
    }
  }

  appLoaded = () => {
    this.setState({ appLoaded: true });
  };

  render() {
    return (
      <div>
        <Route
          exact
          path="/"
          render={(renderProps) => {
            if (this.state.appLoaded) {
              return <Redirect to="/app" />;
            }
            return <LoadingScreen {...renderProps} />;
          }}
        />
        <Route path="/app" component={AppLayout} />
        <Route path="/login" component={Login} />
      </div>
    );
  }
}

App.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js